import i18n from 'i18n';
import { getUserData } from 'api/v2/users/authentication';
import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { UserCacheKeys } from 'types/cacheKeys.types';
import { AvailableLanguages } from 'types/users.types';
import { isExpert } from 'utils/constants';
import { getCustomerIdFromPath } from 'utils/helpers';
import { getStoredAuthData } from 'utils/auth';
import { indexedLanguages } from 'utils/languages';

/**
 * Returns FULL IUser (all fields: subscriptionPlan, IBAN, etc.)
 * Web: logged-in customer (shares cache with useGetLoggedInUserData)
 * Expert: selected customer
 */

function useGetCurrentCustomerData(options?: UseQueryOptions) {
  const sessionId = isExpert
    ? getCustomerIdFromPath()
    : getStoredAuthData('access_token');

  const cacheKey = isExpert
    ? [UserCacheKeys.UserData, sessionId]
    : [UserCacheKeys.UserData];

  const enabled = !!sessionId;

  return useQuery(cacheKey, getUserData, {
    enabled,
    onSuccess: (data) => {
      if (isExpert) return;
      const userLanguage =
        indexedLanguages[data.language] || AvailableLanguages.en;

      if (i18n.language === userLanguage) return;

      i18n.changeLanguage(userLanguage);
    },
    ...(options as any),
  });
}

export default useGetCurrentCustomerData;
